import React, { useEffect, useState } from "react";
import ListaVerificacionService from "../../services/listaVerificacionService";
import { IChoiceGroupOption, IComboBoxOption } from "@fluentui/react";

export const useComboEstados = () => {
  const [estados, setEstados] = useState<IChoiceGroupOption[]>([]);

  const dataEstados = () => {
    ListaVerificacionService.listaEstados()
      .then((res) => {
        setEstados(res.data);
      })
      .catch((e) => {
        alert(e);
      });
  };
  useEffect(() => {
    dataEstados();
  }, []);

  return {
    estados,
  };
};
